import { render, staticRenderFns } from "./LetterResidentContact.vue?vue&type=template&id=56a555bc&scoped=true&"
import script from "./LetterResidentContact.vue?vue&type=script&lang=ts&"
export * from "./LetterResidentContact.vue?vue&type=script&lang=ts&"
import style0 from "./LetterResidentContact.vue?vue&type=style&index=0&id=56a555bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a555bc",
  null
  
)

export default component.exports